import {
  Announcement as AnnouncementIcon,
  EmojiEvents as EmojiEventsIcon,
  Groups as GroupsIcon,
  Forum as ForumIcon,
  QuestionAnswer as QuestionAnswerIcon,
  Lightbulb as LightbulbIcon
} from '@mui/icons-material';

export const communityBoards = [
  {
    title: '공지사항',
    description: '중요한 공지사항과 업데이트를 확인하세요.',
    icon: <AnnouncementIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
    link: '/community/notices'
  },
  {
    title: '합격 스토리',
    description: '다른 학습자들의 합격 이야기를 공유해보세요.',
    icon: <EmojiEventsIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
    link: '/community/success-stories'
  },
  {
    title: '스터디 그룹',
    description: '함께 공부할 스터디 그룹을 찾아보세요.',
    icon: <GroupsIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
    link: '/community/study-groups'
  },
  {
    title: '자유게시판',
    description: '자유롭게 의견을 나누고 소통하세요.',
    icon: <ForumIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
    link: '/community/free-board'
  },
  {
    title: 'Case Brief',
    description: '주요 판례/사례를 정리하고 토론해보세요.',
    icon: <QuestionAnswerIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
    link: '/community/casebrief'
  },
  {
    title: '학습 팁',
    description: '효과적인 학습 방법과 팁을 공유해보세요.',
    icon: <LightbulbIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
    link: '/community/study-tips'
  }
]; 